import { memo } from "react";
import promoVideo from "../../assets/images/Demo.mp4";
import adCreative1 from "../../assets/images/playboxAdCreative1.webp";
import adCreative2 from "../../assets/images/playboxAdCreative2.webp";
import adCreative3 from "../../assets/images/playboxAdCreative3.webp";
import adCreative4 from "../../assets/images/playboxAdCreative4.webp";
import playboxLogo from "../../assets/icons/playboxLogo.svg";
import {
  AdLabel,
  BgImage,
  BrandCenter,
  BrandLayer,
  BrandLogo,
  Card,
  CtaPill,
  FooterLogo,
  Subtitle,
  TextLayer,
  Title,
  Video,
} from "./PlayboxAdCard.styles";

const PLAYBOX_URL = "https://www.playbox.com";

const IMAGE_CREATIVES = [
  {
    src: adCreative1,
    title: "Turn Any Photo Into Video",
    subtitle: "Upload a photo • Get a video",
    cta: "Create AI Video",
  },
  {
    src: adCreative2,
    title: "Create AI Videos",
    subtitle: "Your imagination, in motion",
    cta: "Create Now",
  },
  {
    src: adCreative3,
    title: "Bring Fantasies To Life",
    subtitle: "AI videos in seconds",
    cta: "Try Free Now",
  },
  {
    src: adCreative4,
    title: "More Fun Is Waiting",
    subtitle: "Join free on Playbox.com",
    cta: "Visit Playbox",
  },
];

const COPY = {
  video: {
    title: "Turn Any Photo Into Video",
    subtitle: "Upload a photo • Get a video",
    cta: "Try Free Now",
  },
  brand: {
    title: "More Fun Is Waiting",
    subtitle: "Create AI videos on Playbox.com",
    cta: "Visit Playbox",
  },
};

// One entry per ad slot on a page — each card gets a different creative.
export const PLAYBOX_AD_ROTATION = [
  { variant: "image", creative: 0 },
  { variant: "image", creative: 1 },
  { variant: "image", creative: 2 },
  { variant: "image", creative: 3 },
];

const PlayboxAdCard = ({ variant = "video", creativeIndex = 0 }) => {
  const isBrand = variant === "brand";
  const isImage = variant === "image";
  const imageCreative = IMAGE_CREATIVES[creativeIndex % IMAGE_CREATIVES.length];
  const copy = isImage ? imageCreative : (COPY[variant] ?? COPY.video);

  // Image creatives already have all copy, CTA and logo baked in — show the
  // artwork alone, no overlay.
  if (isImage) {
    return (
      <Card
        $image
        href={PLAYBOX_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Playbox — ${copy.title.toLowerCase()}`}
      >
        <BgImage src={imageCreative.src} alt="" draggable={false} />
      </Card>
    );
  }

  return (
    <Card
      $brand={isBrand}
      href={PLAYBOX_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Playbox — ${copy.title.toLowerCase()}`}
    >
      {isBrand ? (
        <BrandLayer>
          <AdLabel>AD</AdLabel>
          <BrandCenter>
            <BrandLogo src={playboxLogo} alt="Playbox" draggable={false} />
            <Title>{copy.title}</Title>
            <Subtitle>{copy.subtitle}</Subtitle>
          </BrandCenter>
        </BrandLayer>
      ) : (
        <>
          <Video
            src={promoVideo}
            aria-hidden="true"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
          />
          <TextLayer>
            <AdLabel>AD</AdLabel>
            <Title>{copy.title}</Title>
            <Subtitle>{copy.subtitle}</Subtitle>
          </TextLayer>
          <FooterLogo src={playboxLogo} alt="Playbox" draggable={false} />
        </>
      )}
      <CtaPill>{copy.cta}</CtaPill>
    </Card>
  );
};

export default memo(PlayboxAdCard);
